import {
    BellIcon,
    CalendarIcon,
    ChartBarIcon,
    InboxInIcon,
    FolderIcon,
    HomeIcon,
    InboxIcon,
    MenuAlt2Icon,
    UsersIcon,
    XIcon,
} from '@heroicons/vue/outline'
import { SearchIcon } from '@heroicons/vue/solid'



const routes = {
    state: () => ({
        mainNavigation: [
            // { name: 'Dashboard', href: '/', icon: HomeIcon, current: true },
            {
                name: 'Send Email',
                href: '/send-email',
                icon: InboxIcon,
                current: false ,
                roles: [
                    'Admin',
                    'Manager',
                    'Contributor'
                ]
            },
            // { name: 'Tasks', href: '/tasks', icon: FolderIcon, current: false },
            {
                name: 'Clients',
                href: '/clients',
                icon: FolderIcon,
                current: false,
                roles: [
                    'Admin',
                    'Manager',
                    'Contributor'
                ]
            },
            // { name: 'Logs', href: '/logs', icon: InboxIcon, current: false },
            {
                name: 'Users',
                href: '/users',
                icon: UsersIcon,
                current: false,
                roles: [
                'Admin'
            ]}
        ],
        userNavigation: [
            // { name: 'Your Profile', href: '#' },
            // { name: 'Settings', href: '#' },
            { name: 'Sign out', href: '/logout' },
        ]
    }),
    getters: {
        mainRoutes: (state, getters) => {
            const userRole = getters.getGravyUserRole

            return state.mainNavigation.filter(route => {

                return route.roles.includes(userRole)
            })
        },
        userRoutes: state => {
            return state.userNavigation
        }
    }
}

export default routes
